import { IconButton, IconButtonProps, SxProps } from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";

export const FloatingButton: React.FC<{
  sx?: SxProps;
  children?: React.ReactNode;
  icon: React.ReactNode;
  iconButtonProps?: IconButtonProps;
  forceVisible?: boolean;
}> = ({ sx, children, icon, iconButtonProps, forceVisible }) => {
  const [viewIconVisible, setViewIconVisible] = useState<boolean>(false);
  const visible = viewIconVisible || forceVisible;

  return (
    <Box
      sx={{ position: "relative", width: "100%", ...sx }}
      onMouseEnter={() => setViewIconVisible(true)}
      onMouseLeave={() => setViewIconVisible(false)}
    >
      {children}
      <IconButton
        sx={{
          padding: "0 2px",
          position: "absolute",
          right: 0,
          top: "50%",
          transform: "translateY(-50%)",
          opacity: visible ? 0.4 : 0,
          pointerEvents: visible ? "auto" : "none",
          color: "text.disabled",
          "&:hover": { opacity: 0.8 },
        }}
        {...iconButtonProps}
      >
        {icon}
      </IconButton>
    </Box>
  );
};
